import React, { useContext, useMemo, useState } from "react";
import { GetMe } from "@ticketingplatform/api/dist/user/__generated__/queries";
import { useMeQuery } from "@ticketingplatform/api/dist/user/hooks";

type GetMe_me = NonNullable<GetMe["me"]>;

interface UserContextValue {
  user: GetMe_me | undefined;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

const UserContext = React.createContext<UserContextValue>({
  isLoading: true,
  refetch: () => Promise.resolve(),
  user: undefined,
});

interface UserContextProviderProps {
  children: (params: { isInitializing: boolean }) => React.ReactNode;
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({
  children,
}) => {
  const [isInitializing, setIsInitializing] = useState(true);
  const { refetch, loading, data } = useMeQuery({
    onCompleted() {
      setIsInitializing(false);
    },
    errorPolicy: "ignore",
  });

  const value = useMemo(
    () => ({
      isLoading: loading,
      refetch: async () => {
        await refetch();
      },
      user: data?.me || undefined,
    }),
    [data, loading, refetch]
  );

  return (
    <UserContext.Provider {...{ value }}>
      {children({ isInitializing })}
    </UserContext.Provider>
  );
};

export const useUserContext = (): UserContextValue => useContext(UserContext);
